import React from 'react';
import { Select, InputNumber, Button, Text } from '@clockout-dev/design-elements';
import { DeleteOutlined } from '@ant-design/icons';
import { PRODUCT_TYPE_OPTIONS } from '../../../configuration.constants';
import RulesPanel from '../../../../common/rulesPanel/RulesPanel';
import EmptyState from '../../../../common/emptyState/EmptyState';
import styles from '../styles/feeStructureForm.module.scss';

function ProductTypesPanel({ rules = [], onAdd, onRemove, onUpdate }) {
    return (
        <RulesPanel
            onAdd={onAdd}
            addLabel="Add a product type row"
            emptyState={
                <EmptyState
                    title="No product type rules yet"
                    description="Add a row to set a custom advance fee for a product type."
                />
            }
        >
            {rules.map((rule) => (
                <div key={rule.id} className={styles.ruleRow}>
                    <Text as="span" size="s" className={styles.ruleLabel}>if the product is</Text>
                    <Select
                        size="large"
                        value={rule.productType}
                        options={PRODUCT_TYPE_OPTIONS}
                        onChange={(value) => onUpdate(rule.id, 'productType', value)}
                        className={`${styles.select} ${styles.selectMd}`}
                    />
                    <Text as="span" size="s" className={styles.ruleLabel}>the advance fee is</Text>
                    <InputNumber
                        prefix="$"
                        value={rule.fee}
                        onChange={(value) => onUpdate(rule.id, 'fee', value)}
                        min={0}
                        max={999.99}
                        step={0.01}
                        precision={2}
                        controls={false}
                        className={`${styles.inlineNumberInput} ${styles.amountField}`}
                    />
                    <Button
                        type="button"
                        size="s"
                        variant="text"
                        className={styles.deleteButton}
                        onClick={() => onRemove(rule.id)}
                    >
                        <DeleteOutlined />
                    </Button>
                </div>
            ))}
        </RulesPanel>
    );
}

export default ProductTypesPanel;
